import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-colum h-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex justify-content-between bd-highlight mb-3",
  style: {"margin-top":"20px"}
}, null, -1)
const _hoisted_3 = { class: "table table-bordered table-striped table-sm member-list" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"160px"} }, "类型"),
    /*#__PURE__*/_createElementVNode("th", null, "排序")
  ])
], -1)
const _hoisted_5 = { id: "member-list" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", null, "预约入口", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", null, "UVIP入口", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", null, "护理入口", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ImageUploader = _resolveComponent("ImageUploader")!
  const _component_LoadingDialog = _resolveComponent("LoadingDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("table", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("tbody", _hoisted_5, [
          _createElementVNode("tr", null, [
            _hoisted_6,
            _createElementVNode("td", null, [
              _createVNode(_component_ImageUploader, {
                src: _ctx.item.yuyue,
                onUpload: $setup.imageUploadYuyue
              }, null, 8, ["src", "onUpload"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_7,
            _createElementVNode("td", null, [
              _createVNode(_component_ImageUploader, {
                src: _ctx.item.uvip,
                onUpload: $setup.imageUploadVip
              }, null, 8, ["src", "onUpload"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_8,
            _createElementVNode("td", null, [
              _createVNode(_component_ImageUploader, {
                src: _ctx.item.huli,
                onUpload: $setup.imageUploadHuli
              }, null, 8, ["src", "onUpload"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_LoadingDialog, { show: _ctx.showLoadingDialog }, null, 8, ["show"])
  ], 64))
}